<template>
    <div class="headerBox" :class="[root.device=='phone'&&'notransform']">     
         <div class="mlogo" :class="[root.device=='phone'&&'notransform']" @click="goMain"><img  src="@/assets/logoname.png"/></div>
        <div class="left">
            <DvDecoration8 />
        </div>        
        
        <div class="txt" :class="[root.device=='phone'&&'mobile_notransform']">
          <span @click="fullScreen">{{title||'数据看板'}}</span>
          <div v-if="root.device=='phone'">
              <div v-if="openShops"  class="select">
                <div  @click="show_option=!show_option">{{selectedshop==""?shopList[2].storeName:selectedshop}}</div>   
                <div class="option_text"  v-show="show_option">
                    <div  @click="cselect(item)" class="option_text_item"  v-for="(item, index) in shopList" :key="index">
                        <span style="float:left">{{item.storeName}}</span>    
                     
                     <img src="@/assets/l_icon_light@2x.png"/>
                    </div>     
                </div>   
            </div>
          </div>
        </div>
        <Decoration5new :color="['#2E51AE','#070919']" class="line" />
      
        <div class="right">
            
             <DvDecoration8  :reverse="true" />
        </div>
        <div class="time"  v-if="root.device=='phone'"> 
     
        {{dateFormat(date)[0]}}{{dateFormat(date)[1]}}

        </div>
        <div class="time" v-else> <div v-if="openShops"  class="select">
            <div  @click="show_option=!show_option">{{selectedshop==""?shopList[0].storeName:selectedshop}}</div>   
           <div class="option_text"  v-show="show_option">
                 <div  @click="cselect(item)"  class="option_text_item"  v-for="(item, index) in shopList" :key="index">
                    <span style="float:left">{{item.storeName}}</span>    
                     
                     <img  src="@/assets/l_icon_light@2x.png"/>
                </div>     
            </div>   
        </div>{{dateFormat(date)[0]}}{{dateFormat(date)[1]}}</div>
    </div>
</template> 

<script>
    import Decoration5new from '../datav/decoration5new/main';
    import DvDecoration8 from "../vip/decoration8new/main";
  
    export default {
        name: 'mhead',
         inject:['root'],
        props:{
            title:String,
            openShops:Boolean,
            shopList:{
                type:Array,
                default:()=>{
                    return []
                }
            }
        },
        data () {
            return {
                date: new Date(),
                show_option:false,
                selectedshop:""
            }
        },
        watch:{
        
    },
        mounted() {            
            let _this = this;
            this.timer = setInterval(function() {
             _this.date = new Date();            
            },1000);
        },
        beforeDestroy: function() {
            if (this.timer) {
            clearInterval(this.timer);
            }
        },
        methods:{
            fullScreen(){
                this.root.device=this.$isMobile()
                 document.querySelector("body").requestFullscreen();

                //  window.location.reload();
                //  this.root.device=this.$isMobile()
               
             },
          openUrl(){
            var o={};    
             o.name='main'
                o.query={}   
            switch (this.$route.name) {
                case 'bottom':
                    o.query.id=1                    
                    break;
                case 'bigop':
                     o.query.id=2
                     o.params={
                         id:"2689E844B02048C28DEE33577FFCECCE"
                     }
                    break;
                case 'supply':
                     o.query.id=3
                    break;
                case 'design':
                   o.query.id=4
                    break;
                case 'vip2':
                   o.query.id=5
                    break;
                case 'digitalproduction_1':
                     o.query.id=6
                    break;
                case 'digitalproduction_2':
                    o.query.id=7
                    break;
                case 'online':
                    o.query.id=8
                    break;
                case 'production_schedule':
                   o.query.id=9
                    break;
                case 'marketing':
                    o.query.id=10
                    break;
                case 'operate':
                    o.query.id=11
                    break;
                case 'quality_testing':
                   o.query.id=12
                    break;
                case 'warehouse':    
                   o.query.id=13
                   
                    break;
                default:
                    break;
            }
           this.$router.push(o)
        },
            goMain(){          
                this.openUrl()                   
            },
            cselect(item){
                this.$emit("changeShop",item)
                this.show_option=false
                this.selectedshop=item.storeName
            },
            dateFormat:function(date) {
                var year=date.getFullYear();
                var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                
                return [`${month}月${day}日`,`${hours}:${minutes}:${seconds}`];
            }
        },
        components: {
            Decoration5new,
            DvDecoration8          
        }
    }
</script>

<style lang="scss" type="text/scss">
   .headerBox{
       display: flex;
       position: relative;
       width: 100%;
       .select{
           display:inline-block;
           margin-right:10px;
           cursor: pointer;
       }
       .mlogo{
           position: absolute;
           font-family: PingFangSC-Semibold;
           font-size: 1.15vw;
           color: #4EADFF;
           letter-spacing: 0;
           text-align: right;
           top:20px;
           left: 18px;
           img{
               width:270px;
               height:35px;
           }
           &.notransform{
                top:4px !important;
            img{              
           
                width:90px !important;
                height:auto !important;
            }
           }
       }
       .left{
         flex: 1;
       }
       .right{
            flex: 1;
       }
       .txt{
           width:25%;
           font-size: 2.5vw;
           text-align: center;
           color: #fff;
           &.mobile_notransform{
               width:auto  !important;
               font-size: 16px  !important;
               padding: 0px 10px !important;

           }
       }
       .line{
           position: absolute;
         
            top: 56px;
            width: 100%;
            height: 24px;
       }
       .time{
               position: absolute;
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #fff;
            letter-spacing: 0;
            text-align: right;
            top: 26px;
            right: 22px;
       }
       .option_text{

           background:white;z-index:99999;position: relative;
           color: black;
           font-size: 1vw;
           padding: 0vw 1vw 0vw 1vw;
           height: 8vw;
           position: absolute;
           overflow-y: scroll;
           &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
                border-radius: 10px;
                background-color: #F5F5F5;
            }

           .option_text_item{
              height: 50px;
              text-align: center;
              line-height: 50px;
              border-bottom:1px solid #ccc ;
              img{
float:right;margin-top:20px
              }
           }
       }
       &.notransform{
              .time{
                    font-size: 12px !important;
              }
            .option_text{
                  height: 90px !important;
                  &>div{
                      height: 30px;
                      line-height: 30px;
                  }
            }
       }
   }    
   
</style>